import { ORDER_ONLINE_URL, DELIVERY_URL } from "../lib/data";

/**
 * Floating order orbs (mobile only). Sticky bottom-right.
 *  • Top orb (black) — Get Delivery via Uber Eats
 *  • Bottom orb (orange, pulsing) — Order Pickup via Chewzie
 */
export default function FloatingOrderOrb() {
    return (
        <div className="md:hidden fixed z-[60] bottom-5 right-5 flex flex-col items-center gap-3">
            {/* Delivery orb */}
            <a
                href={DELIVERY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-delivery-orb"
                aria-label="Get Delivery via Uber Eats"
                className="relative w-14 h-14 rounded-full bg-[#121212] text-[#FAF8F4] flex items-center justify-center shadow-[0_10px_24px_-8px_rgba(0,0,0,0.5),0_4px_10px_-2px_rgba(0,0,0,0.25)] active:scale-95 hover:bg-[#EB4A18] transition-all duration-300"
            >
                <ScooterIcon />
                <span
                    aria-hidden="true"
                    className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-[#EB4A18] ring-2 ring-[#FAF8F4]"
                />
            </a>

            {/* Pickup orb */}
            <a
                href={ORDER_ONLINE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-order-orb"
                aria-label="Order Pickup"
                className="relative w-16 h-16 rounded-full bg-[#EB4A18] text-[#FAF8F4] flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(235,74,24,0.55),0_4px_10px_-2px_rgba(0,0,0,0.25)] active:scale-95 hover:bg-[#121212] transition-all duration-300"
                style={{ animation: "orbPulse 2.6s ease-in-out infinite" }}
            >
                <BurgerIcon />
                <span
                    aria-hidden="true"
                    className="absolute inset-0 rounded-full ring-2 ring-[#EB4A18]/40"
                    style={{
                        animation: "orbRing 2.6s ease-out infinite",
                    }}
                />
            </a>

            <style>{`
                @keyframes orbPulse {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-3px); }
                }
                @keyframes orbRing {
                    0% { transform: scale(1); opacity: 0.55; }
                    100% { transform: scale(1.55); opacity: 0; }
                }
            `}</style>
        </div>
    );
}

function BurgerIcon() {
    return (
        <svg
            viewBox="0 0 32 32"
            aria-hidden="true"
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M4 12c0-4.4 5.4-8 12-8s12 3.6 12 8" />
            <path d="M4 12h24" />
            <path d="M5 16c1.5-1.5 3-1.5 4.5 0S12.5 17.5 14 16s3-1.5 4.5 0 3 1.5 4.5 0 3-1.5 4.5 0" />
            <rect x="4" y="19" width="24" height="3" rx="1.5" />
            <path d="M4 23c0 3 5.4 5 12 5s12-2 12-5" />
        </svg>
    );
}

function ScooterIcon() {
    return (
        <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Delivery scooter / bag silhouette */}
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="18" r="3" />
            <path d="M9 18h6" />
            <path d="M15 18l-2-9h-3" />
            <path d="M15 9h4l2 4" />
            <path d="M14 13h5" />
        </svg>
    );
}
